import { Divider, IconButton, Stack, SvgIcon } from "@mui/material";
import React, { useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import { MdClose } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import logo_text from "../../assets/logo.png";
import { themeOrange, themeBlue } from "../../utils/colorTheme";
import useWindowDimensions from "../../utils/hooks/windowDimensions";
import { userDashboardRoutes, getFilteredRoutes } from "../../utils/sideRoute";
import { exit_session } from "../../config/apiHandle/apiHandle";
import CustomModal from "../common/CustomModal/CustomModal";
import ButtonComp from "../common/ButtonComp";
import { RxCross2 } from "react-icons/rx";
import { HiOutlineLogout } from "react-icons/hi";
import { TextField } from "@mui/material";

export const UserSideBar = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [openModal, setOpenModal] = useState(false);
  const [prosPasswordModal, setProsPasswordModal] = useState(false);
  const [prosPassword, setProsPassword] = useState("");
  const [prosPasswordError, setProsPasswordError] = useState("");
  const [prosUnlocked, setProsUnlocked] = useState(
    sessionStorage.getItem("pros_unlocked") === "true"
  );

  const PROS_PASSWORD = "done2026";

  const handleProsPasswordSubmit = () => {
    if (prosPassword === PROS_PASSWORD) {
      setProsUnlocked(true);
      sessionStorage.setItem("pros_unlocked", "true");
      setProsPasswordModal(false);
      setProsPassword("");
      setProsPasswordError("");
      navigate("/vendor");
      if (width <= 850) activeChangeHandle();
    } else {
      setProsPasswordError("Incorrect password");
    }
  };

  const { width } = useWindowDimensions();
  const { active, hidden, activeChangeHandle } = props;

  const { sideBarHide } = useSelector((state) => state.layout_controler);

  const handleNavigation = (linkTo) => {
    navigate(linkTo);
    if (width <= 850) {
      activeChangeHandle();
    }
  };

  return (
    <Stack
      spacing={0}
      className={`sidebar ${active && "active"} ${
        hidden && "hidden-side-bar"
      } ${sideBarHide && "hideSideBar"}`}
      justifyContent="space-between"
      sx={{ bgcolor: "#fff", height: "100vh", overflow: "hidden" }}
    >
      <Stack sx={{ flex: 1, minHeight: 0, overflowY: "auto" }}>
        {width > 850 ? (
          <Stack
            direction="row"
            alignItems="center"
            pl={3}
            pt={2.5}
            pb={5}
            spacing={1}
            sx={{ height: "45px" }}
          >
            <img
              onClick={() => navigate("/")}
              className="content-effect-logo-text"
              src={logo_text}
              style={{ cursor: "pointer" }}
            />
          </Stack>
        ) : (
          <Stack
            direction="row"
            alignItems="center"
            paddingX={2}
            justifyContent="space-between"
            pb={3}
          >
            <Stack
              direction="row"
              alignItems="center"
              mt={2.5}
              mb={2}
              spacing={1}
              sx={{ height: "45px" }}
            >
              <img
                onClick={() => navigate("/")}
                className="content-effect"
                style={{
                  width: "100px",
                  transition: "width 0.35s ease-in-out",
                  objectFit: "contain",
                  cursor: "pointer",
                }}
                src={logo_text}
              />
            </Stack>
            <Stack>
              <IconButton onClick={activeChangeHandle} size="large">
                <MdClose color="black" />
              </IconButton>
            </Stack>
          </Stack>
        )}

        <Stack
          style={{ paddingLeft: width > 850 ? "8px" : "10px", paddingRight: "8px", paddingBottom: "12px" }}
          spacing={0.15}
        >
          {React.Children.toArray(
            getFilteredRoutes(localStorage.getItem("admin_role") || "admin").map((e) => {
              const { caption, linkTo, icon, list_in_sidebar } = e;
              const isActivePath = linkTo.split("/")[1];
              const isSidebarActive =
                pathname === "" ? "" : pathname.split("/")[1];
              const isActive = isSidebarActive === isActivePath;

              return (
                list_in_sidebar && (
                  <NavLink
                    style={{
                      textDecoration: "inherit",
                      borderRadius: "8px",
                      height: "32px",
                      display: "flex",
                      alignItems: "center",
                      color: isActive ? themeOrange : "#555",
                      background: isActive ? "#FFF0EB" : "transparent",
                      transition: "all 0.15s ease",
                    }}
                    to={caption === "Pros" && !prosUnlocked ? "#" : `${linkTo}`}
                    onClick={(ev) => {
                      if (caption === "Pros" && !prosUnlocked) {
                        ev.preventDefault();
                        setProsPasswordModal(true);
                        setProsPassword("");
                        setProsPasswordError("");
                        return;
                      }
                      handleNavigation(linkTo);
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      style={{ paddingLeft: "12px" }}
                    >
                      <SvgIcon
                        style={{
                          fontSize: "1rem",
                          color: isActive ? themeOrange : "#888",
                        }}
                      >
                        {icon}
                      </SvgIcon>
                      <Typography
                        noWrap
                        sx={{
                          fontSize: "12.5px",
                          fontWeight: isActive ? 600 : 500,
                          color: isActive ? themeOrange : "#555",
                        }}
                      >
                        {caption}
                      </Typography>
                    </Stack>
                  </NavLink>
                )
              );
            })
          )}
        </Stack>
      </Stack>

      <Stack sx={{ pb: "20px" }}>
        <Divider sx={{ my: 1.5, mx: 2 }} />
        <Stack
          direction="row"
          alignItems="center"
          onClick={() => setOpenModal(true)}
          sx={{
            px: "14px",
            mx: 1,
            py: 1,
            cursor: "pointer",
            borderRadius: "10px",
            transition: "all 0.15s",
            "&:hover": { bgcolor: "#FFEBEE" },
          }}
          gap={1.2}
        >
          <HiOutlineLogout
            style={{ color: "#C62828", fontSize: "1.2rem", flexShrink: 0 }}
          />
          <Typography
            noWrap
            sx={{ color: "#C62828", fontSize: "13px", fontWeight: 500 }}
          >
            Sign Out
          </Typography>
        </Stack>
      </Stack>

      {/* Pros Password Modal */}
      <CustomModal
        isOpen={prosPasswordModal}
        setIsOpen={() => setProsPasswordModal(false)}
      >
        <Stack
          sx={{
            overflow: "auto",
            backgroundColor: "white",
            borderRadius: "16px",
            zIndex: 100000,
            width: { xs: "90vw", sm: "360px" },
          }}
          p={3}
          gap={2}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography sx={{ fontWeight: 700, fontSize: "16px", color: "#1B3A4B" }}>
              Enter Password
            </Typography>
            <IconButton size="small" onClick={() => setProsPasswordModal(false)}>
              <RxCross2 size={16} />
            </IconButton>
          </Stack>
          <Typography sx={{ fontSize: "13px", color: "#888" }}>
            The Pros section is password protected.
          </Typography>
          <TextField
            type="password"
            size="small"
            placeholder="Password"
            value={prosPassword}
            onChange={(e) => {
              setProsPassword(e.target.value);
              setProsPasswordError("");
            }}
            onKeyDown={(e) => e.key === "Enter" && handleProsPasswordSubmit()}
            error={!!prosPasswordError}
            helperText={prosPasswordError}
            autoFocus
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
                "&.Mui-focused fieldset": { borderColor: themeOrange },
              },
            }}
          />
          <Stack direction="row" justifyContent="flex-end" gap={1}>
            <ButtonComp
              onClick={() => setProsPasswordModal(false)}
              label="Cancel"
              style={{
                width: "auto",
                height: "auto",
                padding: "6px 20px",
                borderRadius: "10px",
                background: "#f0f0f0",
                color: "#333",
              }}
            />
            <ButtonComp
              onClick={handleProsPasswordSubmit}
              label="Unlock"
              style={{
                width: "auto",
                height: "auto",
                padding: "6px 20px",
                borderRadius: "10px",
                background: "linear-gradient(135deg, #F15A24 0%, #C53F10 100%)",
              }}
            />
          </Stack>
        </Stack>
      </CustomModal>

      {/* Logout Modal */}
      <CustomModal
        isOpen={openModal}
        setIsOpen={() => setOpenModal(!openModal)}
      >
        <Stack
          sx={{
            overflow: "auto",
            backgroundColor: "white",
            borderRadius: "16px",
            zIndex: 100000,
          }}
          alignItems="center"
          p={1}
        >
          <Stack sx={{ width: "100%" }} alignItems="flex-end">
            <IconButton onClick={() => setOpenModal(!openModal)}>
              <RxCross2 size={18} sx={{ color: "black" }} />
            </IconButton>
          </Stack>
          <Stack gap={2.5} px={2} pb={2} sx={{ width: "100%" }}>
            <Typography
              sx={{ color: "#333", fontSize: "15px", fontWeight: 600 }}
            >
              Are you sure you want to logout?
            </Typography>
            <Stack gap={1.5} direction="row" alignItems="center" justifyContent="flex-end">
              <ButtonComp
                onClick={() => setOpenModal(!openModal)}
                label="Cancel"
                style={{
                  width: "auto",
                  height: "auto",
                  padding: "6px 20px",
                  borderRadius: "10px",
                  background: "#f0f0f0",
                  color: "#333",
                }}
              />
              <ButtonComp
                onClick={() => exit_session()}
                label="Yes, Logout"
                style={{
                  width: "auto",
                  height: "auto",
                  padding: "6px 20px",
                  borderRadius: "10px",
                  background: "linear-gradient(135deg, #C62828 0%, #E53935 100%)",
                }}
              />
            </Stack>
          </Stack>
        </Stack>
      </CustomModal>
    </Stack>
  );
};
